import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";

const Shell = ({ title, children }) => (
  <div className="min-h-screen flex items-center justify-center bg-[var(--navy-deep)] p-6">
    <div className="w-full max-w-sm fade-up">
      <h1 className="font-display text-3xl font-bold text-white mb-8" data-testid="page-title">{title}</h1>
      {children}
      <Link to="/login" className="block text-center text-sm text-white/60 hover:text-white mt-6" data-testid="back-to-login-link">Torna al login</Link>
    </div>
  </div>
);
const cls = "mt-1.5 mb-5 h-12 bg-white/5 border-white/15 text-white";
const btn = "w-full h-12 rounded-full bg-[var(--teal)] hover:bg-[#257474] text-white font-semibold";

export function Activate() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [info, setInfo] = useState(undefined);
  const [f, setF] = useState({ a: "", b: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { api(`/web/activate/${encodeURIComponent(token)}`).then(setInfo).catch((e) => setInfo({ error: e.message })); }, [token]);
  const submit = async () => {
    if (f.a.length < 6) return toast.error("La password deve contenere almeno 6 caratteri");
    if (f.a !== f.b) return toast.error("Le password non coincidono");
    setBusy(true);
    try { await api("/web/activate", { method: "POST", body: { token, password: f.a } }); toast.success("Password salvata: ora puoi accedere"); nav("/login"); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  if (info === undefined) return <Shell title="Attiva account"><p className="text-white/60">Verifica del link…</p></Shell>;
  if (info.error) return <Shell title="Link non valido"><p className="text-white/70" data-testid="activate-error">{info.error}</p></Shell>;
  return (
    <Shell title={`Ciao ${info.nome}`}>
      <p className="text-white/70 mb-6" data-testid="activate-email">Scegli la password per <b className="text-white">{info.email}</b>. Varrà anche per l'app mobile.</p>
      <label className="text-sm text-white/70">Nuova password</label>
      <Input type="password" value={f.a} onChange={(e) => setF({ ...f, a: e.target.value })} className={cls} placeholder="Almeno 6 caratteri" data-testid="activate-password-input" />
      <label className="text-sm text-white/70">Conferma password</label>
      <Input type="password" value={f.b} onChange={(e) => setF({ ...f, b: e.target.value })} className={cls} data-testid="activate-confirm-input" />
      <Button onClick={submit} disabled={busy} className={btn} data-testid="activate-submit-button">{["reset", "forgot"].includes(info.kind) ? "Salva nuova password" : info.kind === "web" ? "Salva password" : "Attiva account"}</Button>
    </Shell>
  );
}

